import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_civils-dark-build/artifacts/3ka8f1dn_Copy%20of%20C%20%287%29.png";

export default function Logo({ className = "" }) {
  return (
    <Link to="/" className={`flex items-center group ${className}`} data-testid="site-logo">
      <img
        src={LOGO_URL}
        alt="City Civils Construction & Landscaping"
        className="h-14 md:h-16 w-auto object-contain"
      />
    </Link>
  );
}
